"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonocleFor = void 0;
var monocle_ts_1 = require("monocle-ts");
var makeMonocleFor = function () { return ({
    lensFromProp: monocle_ts_1.Lens.fromProp(),
    lensFromProps: monocle_ts_1.Lens.fromProps(),
    lensFromPath: monocle_ts_1.Lens.fromPath(),
    indexFromAt: monocle_ts_1.Index.fromAt,
    optionalFromOptionProp: monocle_ts_1.Optional.fromOptionProp(),
    optionalFromNullableProp: monocle_ts_1.Optional.fromNullableProp(),
    prism: monocle_ts_1.Prism.some(),
    prismFromPredicate: monocle_ts_1.Prism.fromPredicate
}); };
var staticMonocle = makeMonocleFor();
/**
 *  @since 0.0.1
 */
var MonocleFor = function () { return staticMonocle; };
exports.MonocleFor = MonocleFor;
